<template>
  <div id="aeon-town-co-ltd">
    <call />
    <!-- header -->
    <header>
      <div class="l-header l-header-grey js-push-to-right push-to-right-grey">
        <div class="l-header__column l-header__column--left pl-16">
          <div class="l-header__btn-menu ssm-toggle-nav">
            <img src="/assets/images/icon/icon_menu_black.svg" class="l-header__btn-menu--open" />
            <img src="/assets/images/icon/icon-close.svg" class="l-header__btn-menu--close" />
          </div>
        </div>
        <div class="l-header__column l-header__column--mid">
          イオンタウン株式会社
        </div>
        <div class="l-header__column l-header__column--right pr-61"></div>
      </div>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <section>
        <div class="l-main l-main--bg-border l-main--no-pd-bot l-main--white pb-50">
          <div class="l-check-cart">
            <div class="l-check-cart__head bg-white">
              <div class="l-check-cart__title l-check-cart__title-small mb-0">
                <img src="/assets/images/logo/icon-aeon-town.svg" alt="" />
              </div>
              <div class="l-check-cart__title l-check-cart__title-large mt-16 mb-0">
                イオンタウン株式会社 <br />
                AEONTOWN Co., Ltd.
              </div>
            </div>
            <div class="l-check-cart__body l-check-cart__body-padding mt-16">
              <div class="c-about-group c-about-group-border-none mb-24">
                <div class="c-about-group__title-list mb-15">
                  <div class="c-about-group__title-list--title">所在地</div>
                  <div class="c-about-group__title-list--big-text">
                    〒261-8515 <br />
                    千葉県千葉市美浜区中瀬1丁目5番地1 イオンタワービル10階
                  </div>
                </div>
              </div>
              <div class="c-about-group__title-list mb-15">
                <div class="c-about-group__title-list--title">URL</div>
                <div class="c-about-group__title-list--big-text">
                  <a href="#" @click.prevent="openCompanySite">https://www.aeontown.co.jp</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import { Tenant } from "../plugin/mixin.js";
import Menu from "../components/Menu.vue";
import { Common } from "../common/common.js";
import Vue from "vue";
export default Vue.extend({
  name: 'Company',
  components: {
    'menu-app': Menu
  },
  mixins: [Tenant],
  mounted() {
    Common.initDom();
  },
  methods: {
    openCompanySite() {
      Common.messageHandlers('show_browser', { url: "https://www.aeontown.co.jp" })
    }
  }
})
</script>